import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { colors, ColorVariant, cssVar } from "./colors";

interface StyledCardProps {
  variant?: ColorVariant;
}
const StyledCard = styled.div<StyledCardProps>(
  ({ variant }) => css`
    box-shadow: 0 0 1px ${cssVar("grey-light")}, 0 1px 3px ${cssVar("grey-light")};
    border-radius: ${cssVar("border-radius-1")};
    display: flex;
    flex-direction: column;
  `
);

const StyledCardTitle = styled.div<StyledCardProps>(
  ({ variant }) => css`
    padding: 0.5em 1em;
    border: ${variant !== undefined
      ? "1px solid " + colors[variant].bgColor
      : "1px solid " + cssVar("grey-light")};
    border-bottom: none;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    font-weight: 500;
    background-color: ${variant !== undefined ? colors[variant].bgColor : cssVar("grey-lightest")};
    color: ${variant !== undefined ? colors[variant].textColor : cssVar("grey-darkest")};
    flex-grow: 0;
  `
);

const StyledCardBody = styled.div<StyledCardProps>(
  ({ variant }) => css`
    flex-grow: 1;
    background-color: ${variant !== undefined ? colors[variant].textColor : cssVar("grey-lightest")};
    padding: 0.5em 1em;
    border: ${variant !== undefined
      ? "1px solid " + colors[variant].bgColor
      : "1px solid " + cssVar("grey-light")};
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit;
    &:only-child {
      border-radius: inherit;
    }
  `
);

/**
 * Overrides the default div props.
 */
export const Card = (
  props: {
    title?: string;
  } & StyledCardProps &
    React.HTMLAttributes<HTMLDivElement>
) => {
  return (
    <StyledCard {...props}>
      {props.title !== undefined && <StyledCardTitle variant={props.variant}>{props.title}</StyledCardTitle>}
      <StyledCardBody variant={props.variant}>{props.children}</StyledCardBody>
    </StyledCard>
  );
};
